var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLandingPageBottomRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 522,
    height: 73,
    viewBox: "0 0 522 73",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M-6.33411e-05 115.118C9.63485 106.44 19.7387 98.0614 30.3139 90.0341C196.225 -35.9036 413.674 -28.7182 516 106.086C517.815 108.478 519.569 110.899 521.288 113.339L473.755 149.419C472.052 146.969 470.315 144.538 468.497 142.143C382.353 28.6554 199.288 22.6052 59.6105 128.63C49.0062 136.679 38.9678 145.147 29.488 153.966L-6.33411e-05 115.118Z",
    fill: "#FEBC2E",
    fillOpacity: 0.6
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLandingPageBottomRight);
export default __webpack_public_path__ + "static/media/landingPageBottomRight.f7ac8eb4cf4b5064976b0cc34bb50eb9.svg";
export { ForwardRef as ReactComponent };